import React from 'react';
import SearchServices from './searchServices';
import './serviceRequest.scss';
const Services = () => {
    
    return <SearchServices />
}

export default Services;